import { render, staticRenderFns } from "./EditTimetable.vue?vue&type=template&id=1226a946&scoped=true&"
import script from "./EditTimetable.vue?vue&type=script&lang=js&"
export * from "./EditTimetable.vue?vue&type=script&lang=js&"
import style0 from "./EditTimetable.vue?vue&type=style&index=0&id=1226a946&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1226a946",
  null
  
)

export default component.exports